(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hdr-chat"]) return;
  try {
    
(function () {
  function init() {
    var wortel = document.querySelector('.hdr-chat');
    if (!wortel) return;
    var knop = wortel.querySelector('.hdr-chat__knop');
    var basis = wortel.dataset.chatUrl || '';
    var frame = null, open = false, chatOrigin = '', herbouw = null, terug = null,
        OPEN_SLEUTEL = 'hdr_chat_open';
    // TERUGVAL (zie het commentaar boven dit blok). Mail en telefoon staan ook
    // in maatcode-worker/src/site/prompt.js (TELEFOON) en in de contactzin van
    // de chatserver; verandert er een, pas ze dan samen aan.
    var gereed = false, mislukt = false, nood = null, klok = null,
        MAIL = 'info@hetdakraam.nl', TEL = '06 53229507', TEL_URL = 'tel:+31653229507';
    // Alleen https. Het adres is een instelling in de theme-editor; een
    // javascript:-adres in een iframe met allow-same-origin draait anders als
    // deze winkel (Codex 28-09).
    try {
      var u = new URL(basis, location.href);
      if (u.protocol !== 'https:') return;
      chatOrigin = u.origin;
    } catch (e) { return; }

    // Het iframe wordt pas gemaakt bij een klik of wanneer de bezoeker de chat
    // in een ander tabblad al open heeft staan. Zo blijft een actief gesprek
    // zichtbaar bij tabwisselen, zonder voor nieuwe bezoekers iets te laden.
    function maakFrame() {
      var f = document.createElement('iframe');
      f.className = 'hdr-chat__paneel';
      f.title = 'Chat met Het Dakraam';
      f.src = basis;
      // allow-scripts + allow-same-origin: het document moet zijn eigen API op
      // hetzelfde subdomein kunnen aanroepen met de sessiecookie.
      // allow-popups + allow-popups-to-escape-sandbox (28-09): de link naar de
      // privacyverklaring in het venster opent in een nieuw tabblad. Zonder
      // allow-popups weigert de browser dat STIL (gemeten 07-09), en zonder de
      // tweede vlag erft dat tabblad deze sandbox en werkt de winkelpagina daar
      // half. maatcode-worker/test/widget-document.test.mjs toetst beide.
      // Nog steeds GEEN allow-top-navigation: het venster mag deze pagina niet
      // wegnavigeren.
      f.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox');
      document.body.appendChild(f);
      // Het load-event vuurt ook op een foutpagina, dus het zegt niet dat de
      // chat er is. Het document meldt 'gereed' tijdens het parsen, vóór zijn
      // eigen load; 2,5 s erna is ruime marge. Vuurt load nooit, dan de klok.
      klok = setTimeout(faal, 12000);
      f.addEventListener('load', function () {
        if (gereed) return;
        clearTimeout(klok);
        klok = setTimeout(faal, 2500);
      });
      return f;
    }

    function faal() {
      if (gereed || mislukt) return;
      mislukt = true;
      // Een bewaard 'open' moet weg, anders staat het venster na herladen
      // vanzelf weer open. Dat sluit ook een ander tabblad; daar laadt de chat
      // in dezelfde browser meestal net zo min.
      bewaarOpen(false);
      var a = document.activeElement,
          focus = open && (!a || a === document.body || a === frame);
      zet();
      if (focus) dicht().focus();
    }

    // Welk paneel er staat: het chatvenster, of zolang dat niet geladen is het
    // terugvalvenster. Het iframe blijft in de DOM: meldt het zich alsnog, dan
    // wisselt dit terug.
    function zet() {
      var n = open && mislukt;
      if (n && !nood) nood = maakNood();
      if (frame) frame.style.display = open && !n ? '' : 'none';
      if (nood) nood.style.display = n ? '' : 'none';
      volg();
    }
    function dicht() { return nood.querySelector('[data-action="sluit-chat"]'); }

    // De stijl komt pas mee als het venster nodig is: de stylesheet hierboven
    // is render-blokkerend en vol, en een gewone bezoeker ziet dit nooit.
    function maakNood() {
      var s = document.createElement('style');
      s.textContent =
        '.hdr-chat__nood{display:flex;flex-direction:column;color:#1A3C5E;font:400 16px/1.5 Lato,system-ui,sans-serif}' +
        '.hdr-chat__nood-kop{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:6px 6px 6px 16px;background:#1A3C5E;color:#fff;font:600 16px/1.3 Poppins,system-ui,sans-serif}' +
        '.hdr-chat__nood-dicht{flex:none;width:44px;height:44px;border:0;border-radius:var(--hdr-radius);background:none;color:#fff;font:400 28px/1 system-ui,sans-serif;cursor:pointer}' +
        '.hdr-chat__nood-dicht:focus-visible{outline:3px solid #E87722;outline-offset:-3px}' +
        '.hdr-chat__nood-romp{padding:20px 16px;overflow:auto}' +
        '.hdr-chat__nood-titel{margin:0 0 8px;font:600 18px/1.3 Poppins,system-ui,sans-serif}' +
        '.hdr-chat__nood-uitleg{margin:0 0 8px}' +
        '.hdr-chat__nood-actie{display:block;box-sizing:border-box;min-height:48px;margin-top:12px;padding:11px 16px;border:2px solid #1A3C5E;border-radius:var(--hdr-radius);background:#fff;color:#1A3C5E;font:600 15px/1.4 Poppins,system-ui,sans-serif;text-align:center;text-decoration:none}' +
        '.hdr-chat__nood-actie--hoofd{background:#1A3C5E;color:#fff}' +
        '.hdr-chat__nood-actie:focus-visible{outline:3px solid #1A3C5E;outline-offset:2px}' +
        '.hdr-chat__nood-noot{margin:12px 0 0;font-size:14px}';
      document.head.appendChild(s);
      var d = document.createElement('div');
      d.className = 'hdr-chat__paneel hdr-chat__nood';
      d.setAttribute('role', 'dialog');
      d.setAttribute('aria-label', 'Chat met Het Dakraam');
      d.setAttribute('aria-describedby', 'hdr-chat-nood-tekst');
      d.innerHTML =
        '<div class="hdr-chat__nood-kop"><span>Chat met Het Dakraam</span>' +
        '<button type="button" class="hdr-chat__nood-dicht" data-action="sluit-chat" aria-label="Sluit dit venster">&times;</button></div>' +
        '<div class="hdr-chat__nood-romp"><div id="hdr-chat-nood-tekst">' +
        '<p class="hdr-chat__nood-titel">De chat laadt niet</p>' +
        '<p class="hdr-chat__nood-uitleg">Het chatvenster kan in deze browser niet laden, bijvoorbeeld door een adblocker of een netwerkfilter. Een collega helpt je graag persoonlijk verder.</p></div>' +
        '<a class="hdr-chat__nood-actie hdr-chat__nood-actie--hoofd" href="mailto:' + MAIL + '">Mail ' + MAIL + '</a>' +
        '<a class="hdr-chat__nood-actie" href="' + TEL_URL + '">Bel ' + TEL + '</a>' +
        '<p class="hdr-chat__nood-noot">Bellen kan op werkdagen van 8:00 tot 17:00.</p></div>';
      d.querySelector('[data-action="sluit-chat"]').addEventListener('click', function () { toon(false); });
      document.body.appendChild(d);
      return d;
    }

    // Op een klein scherm vult het paneel het scherm (zie de stylesheet) en
    // volgt het de visualViewport: gaat het toetsenbord open, dan krimpt die, en
    // het paneel krimpt mee in plaats van dat het invoerveld eronder verdwijnt.
    // offsetTop vangt iOS op, dat de pagina bij een focus alsnog een stuk
    // omhoog schuift, ook met overflow:hidden.
    var PANEEL_KLEIN = window.matchMedia('(max-width: 600px), (max-height: 480px)');
    var vv = window.visualViewport;
    var lift = 0;
    // Geldt voor beide panelen: het chatvenster en het terugvalvenster.
    function volg() {
      var klein = PANEEL_KLEIN.matches;
      [frame, nood].forEach(function (p) {
        if (!p) return;
        if (open && klein && vv) {
          p.style.height = vv.height + 'px';
          p.style.transform = 'translateY(' + vv.offsetTop + 'px)';
        } else {
          p.style.height = '';
          p.style.transform = '';
        }
        // Groot scherm: boven dezelfde balken als de knop (til() meet ze), dus
        // ook boven de cookiebanner. Een inline bottom zou op het volle scherm
        // de bottom:auto van de stylesheet overschrijven, vandaar !klein.
        p.style.bottom = !klein && lift ? (lift + 12) + 'px' : '';
        p.style.maxHeight = !klein && lift ? 'calc(100vh - ' + (lift + 28) + 'px)' : '';
      });
    }
    if (vv) {
      vv.addEventListener('resize', volg);
      vv.addEventListener('scroll', volg);
    }

    function bewaarOpen(aan) {
      try { localStorage.setItem(OPEN_SLEUTEL, aan ? '1' : '0'); } catch (e) {}
    }
    function toon(aan, zonderFocus, nietBewaren) {
      open = aan;
      // Open pas bewaren als het chatdocument zich gemeld heeft (TERUGVAL);
      // dicht altijd.
      if (!nietBewaren && (!aan || gereed)) bewaarOpen(aan);
      if (aan && !frame) frame = maakFrame();
      // Alleen de klasse; of hij de pagina vastzet, bepaalt de media query.
      document.documentElement.classList.toggle('hdr-chat-open', aan);
      zet();
      knop.setAttribute('aria-expanded', aan ? 'true' : 'false');
      knop.style.display = aan ? 'none' : '';
      // De knop verdwijnt bij openen; zonder dit valt de focus terug op <body>
      // en moet een toetsenbordgebruiker de hele pagina door tabben. Focus op
      // het iframe-element opent op mobiel geen toetsenbord. Bij sluiten gaat
      // de focus terug naar wat het venster opende (ook de chatrij op de
      // contactpagina, 20-10), anders naar de knop.
      if (!zonderFocus) {
        if (aan) { terug = document.activeElement; (mislukt ? dicht() : frame).focus(); }
        else (terug && terug !== document.body && document.contains(terug) ? terug : knop).focus();
      }
      // Is een balk verschoven terwijl het paneel open was, dan kon de strook
      // hieronder toen niet gemeten worden (de knop stond op display:none).
      if (!aan && herbouw) herbouw();
    }

    knop.addEventListener('click', function () { toon(!open); });

    // `storage` komt alleen uit een ander tabblad met dezelfde site-origin.
    // Focus verplaatsen zou daar storend zijn, daarom openen/sluiten we stil.
    window.addEventListener('storage', function (ev) {
      if (ev.key === OPEN_SLEUTEL) toon(ev.newValue === '1', true, true);
    });
    try {
      if (localStorage.getItem(OPEN_SLEUTEL) === '1') toon(true, true);
    } catch (e) {}

    // Alleen berichten van het chatdocument zelf. De origin-check staat vóór
    // alles: een bericht van een willekeurige andere frame of tab mag dit paneel
    // niet kunnen bedienen.
    window.addEventListener('message', function (ev) {
      if (ev.origin !== chatOrigin) return;
      var d = ev.data;
      if (!d || d.bron !== 'hdr-chat') return;
      if (d.soort === 'sluiten') toon(false);
      else if (d.soort === 'gereed') {
        gereed = true;
        clearTimeout(klok);
        if (open) bewaarOpen(true);
        if (!mislukt) return;
        // Te laat, maar er: alsnog het chatvenster, met de focus mee als die
        // in het terugvalvenster stond.
        mislukt = false;
        var inNood = nood && nood.contains(document.activeElement);
        zet();
        if (open && inNood) frame.focus();
      }
    });
    // Het chatdocument sluit zelf op Escape; het terugvalvenster doet dat hier.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open && mislukt) toon(false);
    });

    // Zwevende balken onderaan (vergelijkbalk, mobiele bestelbalk): de knop gaat
    // erboven hangen in plaats van eroverheen. Gemeten 27-09 op de live winkel:
    // zonder dit dekte hij "Vergelijk" af en op mobiel de knop "Toevoegen" van de
    // bestelbalk. Bewust zelf gemeten en niet via --hdr-cmp-bar-top: op de mobiele
    // productpagina staat de vergelijkbalk op display:none terwijl hidden false
    // blijft, en dan wordt die haak schermhoog. Beide balken staan in hun
    // stylesheet op bottom 0; alleen de cookiebanner-lift zet een inline bottom,
    // dus die lezen we en niet de computed waarde (die loopt achter tijdens de
    // transitie).
    // Sinds 28-09 telt de cookiebanner zelf ook mee (@1584aa): bij een eerste
    // bezoek lag hij over het midden van de knop, op 320, 390 en 1440. Hij
    // verdwijnt via het hidden-attribuut, en dat ziet de MutationObserver.
    // Sinds 23-10 op desktop (vanaf 750) niet meer voor de knop (@bbd090): daar
    // tilde de banner hem 67 px over de prijs van de vierde kaart op
    // /collections/dakramen, en na de cookiekeuze sprong hij terug. Nu blijft
    // hij op zijn plek, ligt hij zolang de banner open is erboven (klasse
    // hdr-chat--banner) en houdt de banner rechts ruimte voor hem vrij (zie de
    // stylesheet). Het paneel telt de banner wel mee (lift), anders valt de
    // banner over het invoerveld. Op een telefoon blijft alles zoals het was.
    var balken = document.querySelectorAll('[data-hdr-cmp-bar], #ht-msc, #hdr-cookie-banner');
    var BREED = window.matchMedia('(min-width: 750px)');
    function til() {
      var h = 0, hKnop = 0, inBanner = false;
      for (var i = 0; i < balken.length; i++) {
        var b = balken[i];
        if (b.hidden || b.dataset.visible === 'false' || getComputedStyle(b).display === 'none') continue;
        var t = (parseFloat(b.style.bottom) || 0) + b.offsetHeight;
        h = Math.max(h, t);
        if (b.id === 'hdr-cookie-banner' && BREED.matches) inBanner = true;
        else hKnop = Math.max(hKnop, t);
      }
      lift = h;
      wortel.classList.toggle('hdr-chat--banner', inBanner);
      knop.style.bottom = hKnop ? (hKnop + 12) + 'px' : '';
      volg();
      if (herbouw) herbouw();
    }
    if (balken.length) {
      var mo = new MutationObserver(til);
      var ro = 'ResizeObserver' in window ? new ResizeObserver(til) : null;
      for (var j = 0; j < balken.length; j++) {
        mo.observe(balken[j], { attributes: true, attributeFilter: ['hidden', 'style', 'data-visible'] });
        if (ro) ro.observe(balken[j]);
      }
      window.addEventListener('resize', til);
      til();
    }

    // D8: op 320px viel de knop over de rechterkant van de bestelknop en ving
    // 17% van de knopbreedte af. Verbergen zolang een primaire CTA onder de knop
    // doorloopt, op elke breedte. Tot 01-10 gold dit alleen onder 750px, op de
    // aanname dat de knop op desktop niet overlapt. De natoets van 30-09 op live
    // weerlegde dat: op een PDP van 1440 breed ligt de knop (links 1258) 18px
    // over de bestelknop (rechts 1277) en over de volle breedte van de
    // gootstuk-knop (@9647af). Omdat de strook de knop zelf is, verdwijnt hij op
    // desktop alleen zolang een CTA er echt onder zit.
    // Sinds 28-09 telt alleen een CTA die de KNOP ZELF raakt: de strook van de
    // observer is de rechthoek van de knop plus 8px lucht. Tot dan was het
    // "ergens in beeld", en op een productpagina staat de bestelknop bijna de
    // hele eerste schermhoogte in beeld: de chat was daar juist verdwenen waar
    // de meeste vragen vallen. Een vaste strook onderin (de eerste versie van
    // deze fix) miste de knop zodra til() hem boven een balk hing (Codex 28-09).
    // rootMargin ligt vast bij het maken, dus bij elke verschuiving (til(), het
    // einde van de bottom-transitie, draaien, sluiten) komt er een nieuwe.
    // Sinds 01-10 telt ook de afrekenknop op /cart mee (#checkout): gemeten op
    // preview 189227565437 lag de chatknop op 320 breed over "Afrekenen". Die
    // knop staat in de .js-contents die Dawn bij elke aantalwijziging opnieuw
    // rendert, en een vervangen knop is een nieuw element dat de observer niet
    // kent. Daarom zoekt herbouw() de knoppen telkens opnieuw op, en roept een
    // MutationObserver op <main> herbouw() aan zodra een gevolgde knop uit het
    // document verdwijnt of er een bij komt (hooguit eens per frame).
    if (!('IntersectionObserver' in window)) return;
    var CTA = '.product-form__submit, button[name="add"], [data-gk-add], #checkout';
    var ctas = document.querySelectorAll(CTA);
    if (!ctas.length) return;
    var zichtbaar = [], io = null;
    function pas() {
      wortel.classList.toggle('hdr-chat--verborgen', !open && zichtbaar.length > 0);
    }
    function zie(entries) {
      entries.forEach(function (e) {
        var i = zichtbaar.indexOf(e.target);
        if (e.isIntersecting) { if (i === -1) zichtbaar.push(e.target); }
        else if (i > -1) zichtbaar.splice(i, 1);
      });
      pas();
    }
    function px(v) { return -Math.max(0, Math.round(v)) + 'px'; }
    // Tijdens de bottom-transitie (.25s) meet getBoundingClientRect nog de OUDE
    // plek. Gemeten 28-09 op preview 189227565437 (M6): na de scrollsprong naar
    // de bestelbalk lag de knop 11-13 frames over de CTA en kwam de verborgen
    // stand pas na 465-492 ms. Daarom beslaat de strook, zolang de knop kan
    // bewegen, de unie van waar hij nu is en waar hij heen gaat; stilstaand
    // krimpt hij terug tot de knop zelf. Het doel volgt uit de inline bottom, of
    // zonder die uit de rustafstand. Die is calc(16px + safe-area) en de
    // safe-area is in JS niet te lezen, dus hij wordt gemeten als de knop
    // stilstaat zonder inline bottom.
    var rust = 16;
    herbouw = function (stil) {
      ctas = document.querySelectorAll(CTA);
      var r = knop.getBoundingClientRect(), m = 8;
      if (!r.height) return;
      var de = document.documentElement, ch = de.clientHeight;
      stil = stil === true;
      if (stil && !knop.style.bottom) rust = ch - r.bottom;
      var doel = ch - (parseFloat(knop.style.bottom) || rust);
      var boven = stil ? r.top : Math.min(r.top, doel - r.height);
      var onder = stil ? r.bottom : Math.max(r.bottom, doel);
      if (io) io.disconnect();
      zichtbaar = [];
      io = new IntersectionObserver(zie, { threshold: 0, rootMargin:
        px(boven - m) + ' ' + px(de.clientWidth - r.right - m) + ' ' +
        px(ch - onder - m) + ' ' + px(r.left - m) });
      for (var k = 0; k < ctas.length; k++) io.observe(ctas[k]);
      // Zonder knoppen komt er geen eerste melding van de observer, en zou een
      // verborgen chatknop verborgen blijven.
      if (!ctas.length) pas();
    };
    knop.addEventListener('transitionend', function (e) { if (e.propertyName === 'bottom') herbouw(true); });
    window.addEventListener('resize', herbouw);
    var gepland = false;
    new MutationObserver(function () {
      if (gepland) return;
      gepland = true;
      requestAnimationFrame(function () {
        gepland = false;
        var anders = document.querySelectorAll(CTA).length !== ctas.length;
        for (var k = 0; !anders && k < ctas.length; k++) anders = !ctas[k].isConnected;
        if (anders) herbouw();
      });
    }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    // Zonder inline bottom heeft er nog geen transitie gelopen: de knop staat stil.
    herbouw(!knop.style.bottom);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
